import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';

export class PaginatorI18n {

    constructor(private translocoService: TranslocoService) {}

    RangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) { return `0 ${this.translocoService.translate('of')} ${length}`; }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} ${this.translocoService.translate('of')} ${length}`;
    }

    getPaginatorIntl() {
    const paginatorIntl = new MatPaginatorIntl();

    paginatorIntl.getRangeLabel = this.RangeLabel;

    return paginatorIntl;
    }

}
